export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13690.31efa71c.jpg";